<template>
    <Form v-bind="$attrs" :model="info">
        <div class="flex">
            <FormItem prop="credType" style="width: 100px; margin-right: 5px">
                <Select v-model="info.credType" transfer clearable placeholder>
                    <Option
                        v-for="item in this.dict.credType.toList()"
                        :value="item.id"
                        :key="item.id"
                        >{{ item.text }}</Option
                    >
                </Select>
            </FormItem>
            <FormItem prop="credNo" style="flex-grow: 1">
                <Input v-model="info.credNo" placeholder="证件号码" clearable />
            </FormItem>
        </div>
    </Form>
</template>
<script>
import Dict from '_u/dict'

export default {
    name: 'CardType',
    inheritAttrs: false,
    props: {
        // 证件类型
        credType: {
            type: [Number, String],
            default: '',
        },
        // 证件号
        credNo: {
            type: [Number, String],
            default: '',
        },
        populateType: {
            type: String,
            default: 'through',
        },
    },
    data() {
        return {
            info: {
                credType: this.credType,
                credNo: this.credNo,
            },
            dict: {
                credType: Dict.NULL,
            },
        }
    },

    watch: {
        credType(val) {
            this.info.credType = val
        },
        credNo(val) {
            this.info.credNo = val
        },
        info: {
            handler(val) {
                if (val.credType && val.credNo) {
                    this.$emit('on-change', val)
                }
            },
            deep: true,
        },
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            this.loading = true
            Promise.all([Dict.get(['cred_type'])])
                .then((args) => {
                    var [dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
}
</script>
<style lang="less" scoped></style>
